var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagDe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFDA44",
  d: "M.995 21.565C3.255 27.658 9.121 32 16 32s12.744-4.342 15.005-10.435L16 20.174z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M16 0C9.12 0 3.256 4.342.995 10.435L16 11.826l15.005-1.391C28.745 4.342 22.88 0 16 0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D80027",
  d: "M.995 10.435A16 16 0 0 0 0 16c0 1.957.352 3.832.995 5.565h30.01C31.648 19.832 32 17.957 32 16s-.352-3.832-.995-5.565z"
})));
export default SvgFlagDe;